import { enAdresseDeDonnees, reduitLImage } from './image';
import { decoupeAdresseDeDonnees } from './ia';
import { depasseLeTotal } from './soumission';

/**
 * Côté le plus long d'une page photographiée. Plus large qu'un justificatif :
 * une soumission se lit en petits caractères, et le modèle doit pouvoir lire
 * un numéro de position.
 */
export const COTE_PAGE = 2000;

/**
 * Prépare les fichiers d'une lecture de document (soumission ou catalogue).
 *
 * Les photos sont réduites avant l'envoi ; un PDF ou un fichier normalisé part
 * tel quel. Le total est vérifié après réduction, puisque c'est lui que le
 * serveur mesure.
 *
 * @param {File[]} fichiers fichiers choisis, dans l'ordre des pages
 * @returns {Promise<{contenu: string, typeMedia: string, nomFichier: string}[]>} prêts à partir
 * @throws {Error} si l'ensemble reste trop lourd
 */
export async function prepareFichiers(fichiers) {
  const prets = [];
  let octets = 0;
  for (const fichier of fichiers) {
    const estImage = (fichier.type || '').startsWith('image/');
    const source = estImage ? await reduitLImage(fichier, COTE_PAGE) : fichier;
    const adresse = await enAdresseDeDonnees(source);
    const { typeMedia, contenu } = decoupeAdresseDeDonnees(adresse);
    octets += Math.floor((contenu.length * 3) / 4);
    prets.push({
      contenu,
      typeMedia: estImage ? typeMedia || fichier.type : fichier.type || '',
      nomFichier: fichier.name || 'document',
    });
  }
  const trop = depasseLeTotal(octets);
  if (trop) throw new Error(trop);
  return prets;
}
